import React, { useEffect, useState } from "react";
import {
  Button,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Paper,
  Switch,
} from "@mui/material";
import { useMaterialUIController, setLoading } from "context";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import { getColleaguesFromServer } from "controllers/FileController";
import getText from "Translator";
import { sendFileColleaguesToServer } from "controllers/FileController";

let capsule;
let file = "";
let fileInfo;
let selectedlist = [];
export default function SendToColleagueComponent(props) {
  const [limitedSending, setLimitedSending] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [reload, setReload] = useState(new Date());
  const { fileInfo, closeActionSheet } = props;
  const [controller, dispatch] = useMaterialUIController();

  const initComponent = async () => {
    try {
      if (typeof fileInfo.file == "object" && fileInfo.file.length == 1) {
        file = fileInfo.file[0].id;
      } else if (typeof fileInfo.file == "string") {
        file = fileInfo.file;
      } else {
        file = "";
      }

      capsule = fileInfo.capsule;
      setLoading(dispatch, true);
      let newData = {
        file,
        search: "",
      };
      let coleagueUsers = await getColleaguesFromServer(newData, controller);
      setLoading(dispatch, false);
      if (coleagueUsers.success) {
        selectedlist = [];
        coleagueUsers.data.map((item) => {
          if (item.selected) {
            selectedlist.push(item);
          }
        });
        setSelected(selectedlist);
        setLimitedSending(coleagueUsers.limited);
        setData(coleagueUsers.data);
      } else {
        Swal.fire({
          text: getText("warningalert", "fa"),
          position: "bottom-end",
          background: "#f1b3af",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    initComponent();
  }, []);

  const searchChbSelect = async (search) => {
    if (data.length > 0) {
      data
        .filter((a) => a.selected === true)
        .map((sw) => {
          if (
            selectedlist.filter((a) => a.value + "" === sw.value + "")
              .length === 0
          ) {
            selectedlist.push(sw);
          }
        });
    }

    setLoading(dispatch, true);
    let newData = {
      file,
      search,
    };
    let items = await getColleaguesFromServer(newData, controller);

    setLoading(dispatch, false);
    if (items.success) {
      items = items.data;
      items.map((item) => {
        item.selected = false;
      });
      selectedlist.map((item) => {
        let xx = items.filter((a) => a.value + "" === item.value + "");
        if (xx.length > 0) {
          xx[0].selected = true;
        }
      });

      setData(items);
    } else {
      Swal.fire({
        text: getText("warningalert", "fa"),
        position: "bottom-end",
        background: "#f1b3af",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const saveSendToColleague = async () => {
    try {
      let array = [];
      let newDatas = data.filter((s) => s.selected === true);
      // if (newDatas.length == 0) {
      //   Swal.fire({
      //     title: getText("warning", "fa"),
      //     text: getText("nouserselected", "fa"),
      //     confirmButtonText: getText("ok", "fa"),
      //   });
      //   return;
      // }
      if (
        (typeof fileInfo.file == "object" && fileInfo.file.length == 1) ||
        typeof fileInfo.file == "string"
      ) {
        newDatas.map((si) => {
          console.log("ssssssssssss", si);
          let newColleague = {
            file: file,
            user: si.isVirtual === true ? undefined : si.value,
            sender: controller.id,
            virtualGroup: si.isVirtual === true ? si.value : undefined,
            limited: limitedSending,
            capsule: capsule,
            nationalCode:
              typeof fileInfo.file == "string"
                ? fileInfo.nationalCode
                : fileInfo.file[0].nationalCode,
          };
          array.push(newColleague);
        });
        let newData = {
          colleaguelist: array,
          file: file,
          nationalCode:
            typeof fileInfo.file == "string"
              ? fileInfo.nationalCode
              : fileInfo.file[0].nationalCode,
          capsule: fileInfo.capsule,
        };

        setLoading(dispatch, true);
        let result = await sendFileColleaguesToServer(newData, controller);
        console.log("resultresult", result);
        setLoading(dispatch, false);
        if (result.success) {
          Swal.fire({
            title: "",
            text: getText("alertsuccess", "fa"),
            confirmButtonText: getText("ok", "fa"),
          });
          closeActionSheet();
        } else {
          if (result.errorCode === 101) {
            Swal.fire({
              title: getText("warning", "fa"),
              text: getText("invalidtoken", "fa"),
              confirmButtonText: getText("ok", "fa"),
            });
          }
          Swal.fire({
            title: getText("warning", "fa"),
            text: getText("warningalert", "fa"),
            confirmButtonText: getText("ok", "fa"),
          });
        }
      } else {
        let success = 0;
        await Promise.all(
          fileInfo.file.map(async (fil) => {
            array = [];
            newDatas.map((si) => {
              let newColleague = {
                file: fil.id,
                user: si.isVirtual === true ? undefined : si.value,
                sender: controller.id,
                virtualGroup: si.isVirtual === true ? si.value : undefined,
                limited: limitedSending,
                capsule: capsule,
                nationalCode: fil.nationalCode,
              };
              array.push(newColleague);
            });
            let newData = {
              colleaguelist: array,
              file: fil.id,
              capsule: capsule,
              nationalCode: fil.nationalCode,
            };
            let result = await sendFileColleaguesToServer(newData, controller);
            if (result.success) {
              success += 1;
            }
          })
        );
        Swal.fire({
          title: success + "  of  " + fileInfo.file.length,
          text: getText("alertsuccess", "fa"),
          confirmButtonText: getText("ok", "fa"),
        });
        closeActionSheet();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Paper
        component="form"
        style={{
          padding: "1px 4px",
          display: "flex",
          alignItems: "center",
          margin: 0,
          left: 0,
          with: "100% !important",
          right: 0,
          top: 0,
          position: "relative",
          borderRadius: 0,
          backgroundColor: "#ffc7d4",
          zIndex: 9999,
        }}
      >
        <IconButton
          color="primary"
          className="iconButton"
          aria-label="CloseIcon"
          onClick={() => {
            searchChbSelect("");
            setSearch("");
          }}
        >
          <CloseIcon />
        </IconButton>
        <InputBase
          className="input"
          value={search}
          fullWidth={true}
          autoFocus={true}
          onChange={(event) => {
            searchChbSelect(event.target.value);
            setSearch(event.target.value);
          }}
        />
        <IconButton
          color="primary"
          className="iconButton"
          aria-label="search"
          onClick={() => {}}
        >
          <SearchIcon />
        </IconButton>
      </Paper>
      <div
        className="listmenu"
        style={{
          paddingRight: 15,
          paddingLeft: 15,
          maxHeight: 360,
          minHeight: 360,
          overflow: "scroll",
        }}
      >
        <List>
          {data &&
            data.map((item, index) => (
              <ListItem key={index + item.value + ""} className="list">
                <FormControlLabel
                  control={
                    <Switch
                      onChange={(event) => {
                        let coleagueUsers = data;
                        for (let sw of coleagueUsers) {
                          if (sw.value === item.value) {
                            sw.selected = event.target.checked;
                          }
                        }

                        if (!event.target.checked) {
                          selectedlist = selectedlist.filter(
                            (a) => a.value + "" !== item.value + ""
                          );
                        }
                        setData(coleagueUsers);
                        setReload(new Date());
                      }}
                      trackColor="#039dfc"
                      checked={item.selected}
                    />
                  }
                  label={item.text}
                />
              </ListItem>
            ))}
        </List>
      </div>

      <Grid container style={{ flex: 1, flexDirection: "row" }}>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                onChange={(event) => {
                  setLimitedSending(!limitedSending);
                }}
                trackColor="#039dfc"
                checked={limitedSending}
              />
            }
            label={getText("limitedsending", "fa")}
          />
        </Grid>
        <Grid
          item
          xs={3}
          sm={3}
          md={3}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          <Button
            color="primary"
            onClick={() => {
              closeActionSheet();
            }}
          >
            {getText("cancel", "fa")}
          </Button>
        </Grid>

        <Grid
          item
          xs={3}
          sm={3}
          md={3}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          <Button
            color="primary"
            onClick={() => {
              saveSendToColleague();
            }}
          >
            {getText("continue", "fa")}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
